import React from 'react'

const Footer = () => {
  return (
    <footer className='text-center bg-darkest-gray border-t border-border-color text-light-gray-2 py-4'>
        <p className='text-sm'>© 2026 Movie Search App. All rights reserved.</p>
    </footer>
  )
}

export default Footer
